import { jsxs, jsx } from "react/jsx-runtime";
import { useRef, useState, useEffect, useId } from "react";
const DEFAULT_ORGANIC_COLORS = {
  highlight: "#FFFFFF",
  primary: "#7C5CFF",
  deep: "#1A0B4D"
};
const OrganicBlob = ({ level, size, colors }) => {
  const t = useRef(0);
  const [d, setD] = useState("");
  useEffect(() => {
    let raf;
    const tick = () => {
      t.current += 0.012;
      const points = 8;
      const cx = 50;
      const cy = 50;
      const baseR = 36 + level * 6;
      const wobble = 2.5 + level * 7;
      const pts = [];
      for (let i = 0; i < points; i++) {
        const a = i / points * Math.PI * 2;
        const noise = Math.sin(t.current * 1.3 + i * 1.7) * wobble + Math.sin(t.current * 0.7 + i * 0.9) * wobble * 0.5;
        const r = baseR + noise;
        pts.push([cx + Math.cos(a) * r, cy + Math.sin(a) * r]);
      }
      let path = `M ${pts[0][0].toFixed(2)} ${pts[0][1].toFixed(2)}`;
      for (let i = 0; i < points; i++) {
        const p0 = pts[(i - 1 + points) % points];
        const p1 = pts[i];
        const p2 = pts[(i + 1) % points];
        const p3 = pts[(i + 2) % points];
        const c1x = p1[0] + (p2[0] - p0[0]) / 6;
        const c1y = p1[1] + (p2[1] - p0[1]) / 6;
        const c2x = p2[0] - (p3[0] - p1[0]) / 6;
        const c2y = p2[1] - (p3[1] - p1[1]) / 6;
        path += ` C ${c1x.toFixed(2)} ${c1y.toFixed(2)}, ${c2x.toFixed(2)} ${c2y.toFixed(2)}, ${p2[0].toFixed(2)} ${p2[1].toFixed(2)}`;
      }
      path += " Z";
      setD(path);
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [level]);
  const c = colors ?? DEFAULT_ORGANIC_COLORS;
  const uid = useId().replace(/:/g, "");
  const gradId = `organic-g-${uid}`;
  const glowId = `organic-glow-${uid}`;
  const primaryFill = colors ? c.primary : `var(--voice-orb-primary, ${c.primary})`;
  return /* @__PURE__ */ jsxs("svg", { width: size, height: size, viewBox: "0 0 100 100", "aria-hidden": true, children: [
    /* @__PURE__ */ jsxs("defs", { children: [
      /* @__PURE__ */ jsxs("radialGradient", { id: gradId, cx: "35%", cy: "35%", children: [
        /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: c.highlight, stopOpacity: "0.85" }),
        /* @__PURE__ */ jsx("stop", { offset: "22%", stopColor: primaryFill, stopOpacity: "1" }),
        /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: c.deep, stopOpacity: "1" })
      ] }),
      /* @__PURE__ */ jsx("filter", { id: glowId, children: /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: "0.5" }) })
    ] }),
    /* @__PURE__ */ jsx("path", { d, fill: `url(#${gradId})`, filter: `url(#${glowId})` })
  ] });
};
export {
  OrganicBlob
};
//# sourceMappingURL=OrganicBlob.js.map
